<template>
<!-- footer -->
<footer>
    <div class="footer_wrap">
        <p>
            &copy; SAMSUNG
            <span class="link">
                <a href="javascript:" @click="openPrivacyPopup">Privacy</a>
            </span>
        </p>
        <div class="link_site">
            <ul>
                <li>
                    <picture>
                        <source srcset="/static/images/logo_footer-mo.png" media="(max-width: 767px)"><!-- mobile -->
                        <source srcset="/static/images/logo_footer.png" media="(max-width: 1023px)"><!-- tablet -->
                        <img src="/static/images/logo_footer.png" alt="SAMSUNG SKP"><!-- pc -->
                    </picture>
                </li>
            </ul>
        </div>
    </div>
</footer>
<!-- //footer -->
</template>
<script>
import { mapActions, mapGetters }   from 'vuex';
import _                            from 'lodash';
import api                          from '@/service';
import store                        from '@/vuex/store';
import { SDLUtil, StringUtil }      from '@/utils';
// Popup components
import PrivacyPolicyPopup           from '~vb/common/PrivacyPolicyPopup';

export default {
    name: 'ASCFooter',
    methods: {
        openPrivacyPopup() {
            SDLUtil.show(
                PrivacyPolicyPopup,
                {
                    class: 'md_size'
                },
                {
                    width: '780px',
                    height: 'auto',
                    scrollable: true
                },
            );
            
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/main/ASCFooter.vue